<template>
  <a-card :bordered="false">
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="渠道用户名" prop="channelName">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.channelName"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="渠道编码" prop="channelCode">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.channelCode"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="集团编码" prop="channelGroupCode">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.channelGroupCode"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="渠道密钥" prop="channelToken">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.channelToken"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item style="text-align: center" :wrapper-col="{ span: 9, offset: 3 }">
        <a-button
          htmlType="submit"
          type="primary"
          @click="submitEvent"
          :loading="submitLoading"
        >保存
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ChangLianMixins from '@/views/service/serviceProvider/changLianConnection/mixins/ChangLianMixins'
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'ChangLianApiConfigure',
  mixins: [searchForm, ChangLianMixins],
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 10 },
      ruleForm: {},
      tabRule: {
        channelName: [
          { required: true, message: '请输入渠道用户名', trigger: ['blur', 'change'] }
        ],
        channelCode: [
          { required: true, message: '请输入渠道编码', trigger: ['blur', 'change'] }
        ],
        channelGroupCode: [
          { required: true, message: '请输入集团编码', trigger: ['blur', 'change'] }
        ],
        channelToken: [
          { required: true, message: '请输入渠道密钥', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      this.getHttpServices().getServerApiService().post('/dsn/account/query/config', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        if (res) this.ruleForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }
        this.getHttpServices().getServerApiService().post('/dsn/account/edit/config', params).then(res => {
          this.$message.success('API配置成功')
          this.getDetailInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
